import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Col, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import classnames from 'classnames'; // Import classnames for conditional classes
import "./Profile.css";
import { getPatientById, updatePatientProfile } from "../../../api/patient";
import { decryptPatientData } from "../../../utils/common";
import { failed, success } from "../../../utils/Tostify";
import { decryptData } from "../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { handleFileUpload } from "../../../utils/ImageToBase64";
import Loader from "../../../components/Loader/Loader";
import { PatientEmailNotification } from "./Constant";
import { changePassword } from "../../../api/auth";
import { useNavigate } from "react-router";

function ProfilePatient() {
	const [activeTab, setActiveTab] = useState("1"); // Define activeTab in state
	const [selectedImage, setSelectedImage] = useState(null); // State for selected image file
	let user = useSelector(state => state.userReducer.user);
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { getConfirmation } = useConfirmDialog();
    const [userDetails, setUserDetails] = useState(user);
	const [notifications, setNotifications] = useState({
		applicationUpdate: false,
		newTask: false,
		loginRequest: false,
		newMessage: false,
		meetingUpdate: false,
		newAssignment: false,
		supportTicketUpdate: false,
		accessUpdate: false,
		workflowUpdate: false
	});
	const [smsNotification, setSmsNotification] = useState(false);
	const [passwords, setPasswords] = useState({
		oldPassword: '',
		newPassword: '',
		confirmPassword: ''
	});
	const [error, setError] = useState('');
	const navigate = useNavigate();

    const handleImageChange = async(e) => {
		if (e.target.files && e.target.files[0]) {
      const confirmed = await getConfirmation({
        title: "Attention!",
        actionBtnTitle: "Yes",
        message : `Are you sure want to update the profile photo ?`
      });
      if (confirmed) {
        setSelectedImage(URL.createObjectURL(e.target.files[0]));
        let res;
        try {
          setIsLoading(true);
          const values = {
            profileImage : e.target.files[0]
          };
          let base64OrgLogo = "";
          if (values?.profileImage) {
              base64OrgLogo = await handleFileUpload(values?.profileImage);
          }
          const profileImageURL = {
			base64Image: base64OrgLogo,
            name: values?.profileImage.name
          };
          values.profileImage = profileImageURL;
          res = await updatePatientProfile({ payload: values, dispatch, token, patientId: user?._id });
          if (res?.status == "SUCCESS") {
              await getPatient();
              setIsLoading(false);
              success(res?.message);
          }else{
              failed(res.data.message);
              setIsLoading(false);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      }
      }
	}
	};

    const getPatient = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getPatientById({ dispatch, token, id: user?._id, userId : user?._id });
            const responseData = decryptData(res.data);
            const decryptedPatient =await decryptPatientData(responseData);
            if (res?.status === "SUCCESS") {
                setUserDetails(decryptedPatient);
				setSmsNotification(decryptedPatient?.smsNotification);
				setNotifications(decryptedPatient?.emailNotifications);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    useEffect(()=>{
		getPatient();
	},[]);

	const handleToggle = async (key) => {
		try {
		// Ask for confirmation
		const confirmed = await getConfirmation({
			title: "Attention!",
			actionBtnTitle: "Yes",
			message: `Are you sure you want to update your profile?`
		});

		if (confirmed) {
			// Proceed with the toggle update only after confirmation
			const updatedNotifications = { ...notifications, [key]: !notifications[key] };
			setIsLoading(true);

			// Call API to update profile
			const res = await updatePatientProfile({
			payload: { emailNotifications: updatedNotifications },
			dispatch,
			token,
			patientId: user?._id
			});

			if (res?.status === "SUCCESS") {
			success(res?.message);
			getPatient(); // Refresh user data
			} else {
			failed(res?.message);
			}
		}
		} catch (error) {
		// console.error("Error during confirmation or toggle update:", error);
		} finally {
		setIsLoading(false);
		}
	};

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};
	const handleChange = (e) => {
		const { name, value } = e.target;
		setPasswords((prev) => ({ ...prev, [name]: value }));
		setError(''); // Clear errors on input change
	};

	const handleUpdatePassword = async (e) => {
		e.preventDefault();

		if (passwords.newPassword !== passwords.confirmPassword) {
			setError('New password and confirm password do not match.');
			return;
		}
		let res;
		try {
			setIsLoading(true);
			res = await changePassword({ values : { oldPassword: passwords.oldPassword, newPassword: passwords.newPassword }, dispatch, token });
			if (res?.status == "SUCCESS") {
			setIsLoading(false);
			success(res?.message);
			setPasswords({ oldPassword: '', newPassword: '', confirmPassword: '' });
			getPatient();
			} else {
			setIsLoading(false);
			failed(res?.message);
			}
		} catch (err) {
			// console.error("Error confirming action:", error);
		}
	};

	const handleToggleChange = async () => {
	try {
		const confirmed = await getConfirmation({
			title: "Attention!",
			actionBtnTitle: "Yes",
			message: `Are you sure you want to update your profile?`
		});

		if (confirmed) {
			const updatedNotification = !smsNotification; // Calculate the new state
			setSmsNotification(updatedNotification); // Update the state only after confirmation
			setIsLoading(true);

			const res = await updatePatientProfile({
				payload: { smsNotification: updatedNotification },
				dispatch,
				token,
				patientId: user?._id
			});

			if (res?.status === "SUCCESS") {
				setIsLoading(false);
				success(res?.message);
				getPatient();
			} else {
				setIsLoading(false);
				failed(res?.message);
			}
		}
	} catch (error) {
		// console.error("Error confirming action:", error);
	}
	};

	const patientDeatils = userDetails;

	return (
		<Fragment>
			{isLoading && <Loader />}
			<div className='profile_container'>
				<div>
					<Nav tabs>
						<NavItem>
							<NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggle('1')}>
								My Profile
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggle('2')}>
								Settings
							</NavLink>
						</NavItem>
					</Nav>
					<TabContent activeTab={activeTab}>
						<TabPane tabId="1">
							<Row>
								<Col sm="12">
									<div className='profile_block'>
										<div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
											<div className='profile_info flex-wrap'>
												{/* <img src={} alt="img_profile" className="img_profile_one" /> */}
												{/* Image Upload and Preview */}
												<div className="img_block">
													<div className="img_profile_container">
														{selectedImage ? (
															<img src={selectedImage} alt="Profile" className="img_profile_one" />
														) : (
															<img
																src={userDetails?.profile_image?.signedUrl} // Placeholder image if none is selected
																alt="Profile"
																className="img_profile_one"
															/>
														)}
													</div>
													<div className="edit_img">
														<i className='fas fa-pen'></i>
													</div>
													<input
														type="file"
														accept="image/*"
														onChange={handleImageChange}
														className="img_upload_input"
													/>
												</div>
												<div>
													<h6>{userDetails?.name?.text}</h6>
													<p>{userDetails?.telecom[1].value}</p>
												</div>
											</div>
											<button className='edit_profile' onClick={()=> navigate("/app/patient/edit-profile", {state : {patientDeatils}})}>Edit Profile</button>
										</div>
										<div className='data_profile'>
											<div className="info_block">
												<h4>Personal Information</h4>
												<div className="row">
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Date Of Birth : <span>{userDetails?.birthDate}</span></p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_two_profile">
														<p>Gender : <span>{userDetails?.gender}</span></p>
													</div>
												</div>
											</div>
											<div className="info_block mt-4 mb-4">
												<h4>Contact Information</h4>
												<div className="row mb-3">
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Address : <span>{userDetails?.address?.line}</span></p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Phone Number : <span>{userDetails?.gender}</span></p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_two_profile">
														<p>Country : <span>{userDetails?.address?.state}</span></p>
													</div>
												</div>
												<div className="row mb-3">
													<div className="col-lg-4 col-md-6 col-sm-12 space_two_profile">
														<p>City : <span>{userDetails?.address?.city}</span></p>
													</div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Pincode : <span>{userDetails?.address?.postalCode}</span></p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</Col>
							</Row>
						</TabPane>
						<TabPane tabId="2" className="profile_tab_two">
							<div className='profile_main_two'>
								<div className="table_space">
									<div className="table-responsive">
										<table>
											<thead>
												<tr className="header_table">
													<th>
														Email Notifications
													</th>
													<th>
														Actions
													</th>
												</tr>
											</thead>
											<tbody>
											{PatientEmailNotification?.map((item, index) => (
											<React.Fragment key={item.key}>
											<tr>
												<td colSpan={9} height={5} className="bg_light"></td>
											</tr>
											<tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
												<td>{item.label}</td>
												<td>
												<div className="toggle">
													<input
													type="checkbox"
													id={`checktoggle-${item.key}`}
													checked={notifications[item.key]}
													onChange={() => handleToggle(item.key)}
													/>
													<label htmlFor={`checktoggle-${item.key}`}></label>
												</div>
												</td>
											</tr>
											</React.Fragment>
										))}
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div className="profile_main_three">
								<div className="table-responsive">
									<table>
										<tbody>
											<tr>
												<td><h5>SMS Alerts</h5></td>
												<td className="">
													<div className="toggle">
													<input
														type="checkbox"
														id="smsNotification"
														checked={smsNotification}
														onChange={handleToggleChange}
														/>
														<label htmlFor="smsNotification"></label>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div className="profile_main_four">
								<h5>Password Management :</h5>
								<div className="d-flex justify-content-between mt-4 gap-5 form_block_org">
									{['Current Password', 'New Password', 'Confirm Password'].map((label, index) => {
									const field = ['oldPassword', 'newPassword', 'confirmPassword'][index];
									return (
										<div className="form_password" key={field}>
										<FormGroup>
											<Label for={field}>{label}</Label>
											<Input
											id={field}
											name={field}
											type="password"
											value={passwords[field]}
											onChange={handleChange}
											required
											/>
										</FormGroup>
										</div>
									);
									})}
								</div>
								{error && <p className="text-danger">{error}</p>}
								<div className="text-center reset_blk">
									<button className="reset_block" onClick={(e)=>handleUpdatePassword(e)}>Update Password</button>
								</div>
							</div>
						</TabPane>
					</TabContent>
				</div>
			</div>
		</Fragment>
	);
}
export default ProfilePatient;
